import { Box, Typography } from '@dtx-company/design-system/src'
import { FC } from 'react'
import { GeneratorBannerData } from '../HomepageStaticContent/types'
import { Box as LegacyBox } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { RichText } from 'prismic-reactjs'
import { Text } from '@dtx-company/shared-components/src/components/atoms/Text/index'
import { asText } from '@prismicio/client'
export const GENERATOR_BANNER_ID = 'generator-banner'
export const GeneratorBannerDesktopV2: FC<{
  data: GeneratorBannerData
}> = ({ data }) => {
  return (
    <Box
      id={GENERATOR_BANNER_ID}
      sx={{
        alignItems: 'center',
        color: data.primary.font_color,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        mt: 6
      }}
    >
      {data?.primary?.header && (
        <Typography variant={data?.primary.font_variant ?? 'headlineLarge'} component="h1">
          {asText(data.primary.header)}
        </Typography>
      )}
    </Box>
  )
}

export const GeneratorBannerMobile: FC<{
  data: GeneratorBannerData
}> = ({ data }) => {
  return (
    <LegacyBox backgroundColor="primary.black" width="100%" justifyContent="center">
      {data?.primary?.heading && (
        <Text
          textAlign="center"
          color="primary.white"
          fontWeight="bold"
          padding="5px"
          variant="body/small"
          {...(data.primary.font_color && { color: data.primary.font_color })}
          {...(data.primary.font_size && { fontSize: data.primary.font_size + 'px' })}
        >
          {RichText.asText(data.primary.heading)}
        </Text>
      )}
    </LegacyBox>
  )
}
